module.exports = __webpack_public_path__ + "img/no_data.3b1e616b.png";